import React from 'react';
import './assets/styles/style.scss';
import ReactDOM from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import configureSentry from './config/sentry';
import store from './config/redux-store';
import history from './config/history';
import ErrorBoundary from './components/xr/error-boundary';
import Root from './routes';
import * as serviceWorker from './serviceWorker';

configureSentry();

const render = () => {
  ReactDOM.render(
    <AppContainer>
      <ErrorBoundary>
        <Root store={store} history={history} />
      </ErrorBoundary>
    </AppContainer>,
    document.getElementById('app-root')
  );
};

render();

// Hot reloading
if ((module as any).hot) {
  // Reload components
  (module as any).hot.accept('./routes', () => render());
}
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
